import { hbs } from 'ember-cli-htmlbars';
export default hbs("{{assert \'<Form>: You have to specify @onSubmit\' @onSubmit}}\n\n<form ...attributes {{on \'submit\' this.submitForm}}>\n  {{yield}}\n</form>")